import React from 'react';

const HydrogenInitiativesText = () => {
  return (
    <div
      style={{
        fontSize: '22px',
        fontWeight: '400',
        lineHeight: '36.57px',
        
        fontFamily: 'Times New Roman, Times, serif',
        color: "#555555"
      }}>

      <p style={{ marginBottom: '10px', fontSize: 22 }}>
        <strong>Legislative Committee Approves Proposed Law on Incentives for Green Hydrogen Initiatives</strong>
      </p>

      <h2 style={{ marginBottom: '20px' }}>Key Points</h2>
      <ul
        style={{
          marginBottom: '20px',
          listStyleType: 'disc',
          paddingLeft: '20px',
        }}>
        <li style={{ marginBottom: '20px' }}>
          Legislative Support for Green Hydrogen Projects
        </li>
        <li style={{ marginBottom: '20px' }}>
          Alignment with Clean Energy Goals
        </li>
        <li style={{ marginBottom: '20px' }}>Economic Impact</li>
        <li style={{ marginBottom: '20px' }}>
          Integration with Egypt's Vision 2030
        </li>
        <li style={{ marginBottom: '20px' }}>
          National Green Hydrogen Strategy
        </li>
      </ul>
      <p style={{ marginBottom: '20px' }}>
        The Energy and Environment Committee of Egypt's House of Representatives
        has approved a government bill offering tax and non-tax incentives for
        green hydrogen projects. Aligned with Egypt's push for clean energy, the
        legislation supports the production of green hydrogen, ammonia, and
        fuel.
      </p>
      <p style={{ marginBottom: '20px' }}>
        This strategic move is expected to generate employment opportunities,
        bolster national income, and contribute to a reduction in emissions,
        aligning with broader environmental conservation goals. President
        El-Sisi has directed the government to promptly initiate the agreed-upon
        projects and provide the essential infrastructure for their execution.
      </p>
      <p style={{ marginBottom: '20px' }}>
        This initiative is a pivotal element of Egypt's Vision 2030, reflecting
        the nation's dedication to comprehensive development with economic
        returns that will significantly contribute to national progress.
      </p>
      <p style={{ marginBottom: '20px' }}>
        The National Green Hydrogen Council officially sanctioned the National
        Green Hydrogen Strategy, aiming to secure 5 to 8 percent of the global
        hydrogen market. This ambitious endeavor aligns with Egypt's commitment
        to reducing carbon dioxide emissions by an impressive 40 million tons
        annually. Additionally, the strategy outlines ambitious targets for job
        creation, aiming to generate 100,000 employment opportunities by 2040,
        and a substantial boost to the gross domestic product by USD 10 to USD
        18 billion.
      </p>
      <p style={{ marginBottom: '20px' }}>
        This legislative approval marks a crucial step towards achieving Egypt's
        goals in sustainable energy, emphasizing the nation's commitment to a
        green future and positioning itself as a prominent player in the global
        shift towards cleaner, greener technologies.
      </p>
    </div>
  );
};

export default HydrogenInitiativesText;
